import { Link } from '@tanstack/react-router';
import { SquareTerminal } from 'lucide-react';
import { useWorkspaceId } from '@/lib/hooks';
import { t } from '@/lib/i18n';
import { cn } from '@/lib/utils';

/** "How was this made?" — opens the run's runtime session on the Sessions page. */
export function SessionLink({
  executionId,
  label = t('Session'),
  className,
  workspaceId: given,
}: {
  executionId: string | null | undefined;
  label?: string;
  className?: string;
  /** Defaults to the workspace of the current page. */
  workspaceId?: string;
}) {
  const current = useWorkspaceId();
  const workspaceId = given || current;
  if (!executionId || !workspaceId) return null;
  return (
    <Link
      to="/w/$workspaceId/sessions"
      params={{ workspaceId }}
      search={{ session: executionId }}
      className={cn('inline-flex items-center gap-1 text-xs text-muted-foreground hover:text-primary hover:underline [&_svg]:size-3.5', className)}
      title={t('Open the agent’s session: how its runtime got to this, step by step')}
    >
      <SquareTerminal /> {label}
    </Link>
  );
}
